import { baseApi } from "./base.api";
import { API_CONFIG } from "../config/api.config";

class NotificationService {
  getRecipients() {
    return baseApi.get(API_CONFIG.ENDPOINTS.NOTIFICATIONS.RECIPIENTS);
  }

  getNotifications() {
    return baseApi.get(API_CONFIG.ENDPOINTS.NOTIFICATIONS.SHOW);
  }

  createNotification(data) {
    return baseApi.post(API_CONFIG.ENDPOINTS.NOTIFICATIONS.CREATE, data);
  }

  deleteNotification(id) {
    return baseApi.delete(API_CONFIG.ENDPOINTS.NOTIFICATIONS.DELETE(id));
  }
}

export const notificationService = new NotificationService();
